import React from "react";
import ReunionesTemplate from "../components/templates/ReunionesTemplate";

const Reuniones = () => {
    return( 
        <ReunionesTemplate/> 
    );
};

export default Reuniones;